import {
  FILTERED_INPUT_DATA_REQUEST,
  FILTERED_INPUT_DATA_SUCCESS,
  FILTERED_INPUT_DATA_FAILURE,
} from "./filteredInputDataType";
const initialState = {
  success: false,
  loading: false,
  inputData: [],
  error: "",
};
const filteredInputDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case FILTERED_INPUT_DATA_REQUEST:
      return {
        ...state,
        success: false,
        loading: action.loading,
      };
    case FILTERED_INPUT_DATA_SUCCESS:
      const setSignUpState = {
        ...state,
        success: true,
        loading: action.loading,
        inputData: action.payload,
        error: "",
      };
      return setSignUpState;
    case FILTERED_INPUT_DATA_FAILURE:
      return {
        ...state,
        success: false,
        loading: action.loading,
        inputData: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
export default filteredInputDataReducer;
